import {buttonStyles} from "./buttonStyles";

export const ghostButtonsColorClassnames = {
    [buttonStyles.ghost.accentOutline]: 'button--accent-outline',
    [buttonStyles.ghost.altAccentOutline]: 'button--alt-accent-outline',
    [buttonStyles.ghost.blackOutline]: 'button--black-outline',
    [buttonStyles.ghost.whiteOutline]: 'button--white-outline',
};